import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es"

// Connects to data-controller="flatpickr"
//
// Options are read from `data-flatpickr-*` attributes on the element, e.g.
//   data-flatpickr-date-format="d/m/Y"
//   data-flatpickr-max-date="today"
//   data-flatpickr-allow-input="true"
// which map to the flatpickr options dateFormat, maxDate and allowInput.
export default class extends Controller {
  connect() {
    this.fp = flatpickr(this.element, {
      ...this.optionsFromDataset(),
      locale: { ...Spanish, firstDayOfWeek: 1 }
    })
  }

  disconnect() {
    this.fp?.destroy()
  }

  optionsFromDataset() {
    const prefix = "flatpickr"
    const options = {}

    for (const [key, rawValue] of Object.entries(this.element.dataset)) {
      if (key === prefix || !key.startsWith(prefix)) continue

      const option = key.charAt(prefix.length).toLowerCase() + key.slice(prefix.length + 1)
      options[option] = this.coerce(rawValue)
    }

    return options
  }

  coerce(value) {
    if (value === "true") return true
    if (value === "false") return false
    if (value !== "" && !isNaN(value)) return Number(value)
    return value
  }
}
